import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "react-loading-skeleton/dist/skeleton.css";
import Header from "../components/header/boardHeader";
import Avatar from "@mui/material/Avatar";
import Button from "../components/button/button";
import SearchInput from "../components/input/searchInput"
import Pagination from "../components/pagination/pagination"
import { Oval } from "react-loader-spinner";
import Tooltip from '@mui/material/Tooltip';
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import RightDrawer from '../components/addCandidates/rightDrawer'
import MiniRightDrawer from "../components/addCandidates/miniRightDrawer";
// Import supabase configuration
import supabase from "../config/supabase";

function Candidates() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [showLoader, setShowLoader] = useState(true);
    const [candidatesDraft, setCandidatesDraft] = useState([]);
    const [colNames, setColNames] = useState([]);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)
    const [candidateDetails, setCandidateDetails] = useState();
    const [showMessage, setShowMessage] = useState(false);
    const [successfullMessage, setSuccessfullMessage] = useState("");
    const [searchValue, setSearchValue] = useState('');
    const [searchData, setSearchData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setDataPerPage] = useState([]);
    const [selected, setSelected] = useState();
    const [wrongProspects, setWrongProspects] = useState([]);
    const [completedProfiles,setCompletedProfiles] = useState([])
    const [toCompleted,setToCompleted] = useState(true);
    const [showInputBox, setShowInputBox] = useState(false);
    const [showSecondInput, setShowSecondInput] = useState(false);
    const [miniScreen, setMiniScreen] = useState(false);
    const [showMiniDrawer,setShowMiniDrawer] = useState(false);
    const [dataPerPageInput, setDataPerPageInput] = useState(10);
    const [numberOfCandidatePerPage, setNumberOfCandidatePerPage] = useState(10);
    const [allMemojis,setAllMemojis] = useState([]);
    const [allGaperIds,setAllGaperIds] = useState([]);
    const [showDeleteCandidateModal, setshowDeleteCandidateModal] = useState(false);
    const [boardInProfiles,setBoardInProfiles] = useState([]);
    useEffect( async() => {
        window.addEventListener('resize', (e) => reportWindowSize(e));
        reportWindowSize();
        let candidates = JSON.parse(localStorage.getItem("candidates")) || [];
        let isToCompleted = localStorage.getItem("showDraft");
        isToCompleted && setToCompleted(!isToCompleted);
        localStorage.removeItem("showDraft");
        getAllCandidates();
        const { data, error } = await supabase
            .from('avatars')
            .select('*')
            .eq('isAssigned', 'false')
        
        if (data && data.length) {
            var avatars = [...data];
            avatars = data.map((d) => {
            var newAvatarObject = { ...d }
            newAvatarObject.color = getRandomColor();
            return newAvatarObject
            })
            setAllMemojis(avatars)
            var countAvatar = 0
            candidates?.forEach((candidate) => {
                candidate.memoji = avatars[countAvatar];
                if(countAvatar+1 >= avatars.length ){
                    countAvatar = 0
                } else {
                    countAvatar++; 
                }
            })
        }
        candidates = candidates.sort(function(a, b) {
            const nameA = a.Name.toUpperCase(); // ignore upper and lowercase
            const nameB = b.Name.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
          
            // names must be equal
            return 0;
          });
        checkError(candidates);
        setCandidatesDraft(candidates);
        // console.log(candidates, Object.keys(candidates[0]))
        candidates?.length > 0 && setColNames(Object.keys(candidates[0]));
    }, [localStorage.getItem("candidates")]);

    useEffect(() => {
        getCurrentPost();
        let candidates = JSON.parse(localStorage.getItem("candidates")) || [];
        checkError(candidates);
    },[currentPage, candidatesDraft, completedProfiles, toCompleted,searchData, numberOfCandidatePerPage])

    useEffect(() => {
        if(dataPerPage.length > 0){
            var selectedObj = dataPerPage[0];
            selectedObj.index = 0;
            setSelected(selectedObj);
            setShowLoader(false);
        }
    },[dataPerPage])

    useEffect(()=>{
        getAllCandidates();
    }, [candidatesDraft])

    const getAllCandidates = async() => {
        const { data, error } = await supabase
            .from('all_profiles')
            .select('*')
        if(data && data.length > 0) {
            console.log(data);
            var allCandidates = [];
            var allIds = [];
            data.map((candidate)=>{
                allIds.push(candidate['serial_no'].toString());
                var candidateObject = {};
                candidateObject['Name'] = candidate['full_name'];
                candidateObject['Gaper Id'] = candidate['serial_no'].toString();
                candidateObject['Exp'] = `${candidate['exp']} years`;
                candidateObject['Location'] = candidate['location'];
                candidateObject['Internal Rate'] = `${candidate['expected_hourly_rate'].toString()} USD/Hour`;
                candidateObject['Time zone'] = candidate['timezone'];
                candidateObject['Title'] = candidate['current_job_title'];
                candidateObject['Language proficiency'] = candidate['language_proficiency'];
                candidateObject['Contract status'] = candidate['contract_status'];
                candidateObject['Industry'] = candidate['industries'];
                candidateObject['Overlapping hours'] = candidate['overlapping_hours'];
                candidateObject['State'] = candidate['states'];
                candidateObject['Email'] = candidate['email'];
                candidateObject['Availability'] = candidate['availability'];
                candidateObject['Skills'] = candidate['skill_level'];
                candidateObject['CvLink'] = candidate['cv_link'];
                candidateObject['cv_name'] = candidate['cv_name'];
                candidateObject['id'] = candidate['id'];
                candidateObject['memoji'] = {};
                candidateObject['memoji']['avatar_url'] = candidate['emoji_url'];
                candidateObject['memoji']['color'] = getRandomColor();
                allCandidates.push(candidateObject);
            })
            console.log(allCandidates);
            allCandidates = allCandidates.sort(function(a, b) {
                const nameA = a.Name.toUpperCase(); // ignore upper and lowercase
                const nameB = b.Name.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
              
                // names must be equal
                return 0;
              });
            setAllGaperIds(allIds);
            setCompletedProfiles(allCandidates);
            setColNames(Object.keys(allCandidates[0]))
        }
    }

    const deleteCandidate = (id,cvName) => async (e)=>{
        e.preventDefault();
        setshowDeleteCandidateModal(false);
        setShowLoader(true);
        setIsDrawerOpen(false);
        setShowMiniDrawer(false);
        console.log(boardInProfiles);
        var all_candidate = [...completedProfiles];
        all_candidate = all_candidate.filter((candidate)=>candidate['id'] !== id);
        var search_candidate = [...searchData];
        search_candidate = search_candidate.filter((candidate)=>candidate['id'] !== id);
        setCompletedProfiles(all_candidate);
        setSearchData(search_candidate);
        setShowLoader(false);
        if(boardInProfiles && boardInProfiles.length > 0){
                var count = 0;
                var profilePrecessed = 0;
                boardInProfiles.forEach(async(board)=>{
                    var board_profileData = await supabase
                    .from("board_profiles")
                    .select("*")
                    .match({board:board.id})
                    if(board_profileData.data && board_profileData.data.length){
                        for(let i=0; i < board_profileData.data.length; i++){
                            let boardProfiles = board_profileData.data[i]?.profiles;
                            console.log(boardProfiles);
                            let new_profiles = boardProfiles?.filter((candidate)=>candidate['id'] !==id);
                            console.log(new_profiles)
                            const { data, error } = await supabase
                            .from("board_profiles")
                            .update({ profiles: new_profiles })
                            .match({id : board_profileData.data[i].id});
                            if(data && data.length){
                                count = 1;
                            }
                        }
                    }
                    var board_profileData = await supabase
                    .from("board_clients_invitation")
                    .select("*")
                    .match({board:board.id})
                    if(board_profileData.data && board_profileData.data.length){
                        for(let i=0; i < board_profileData.data.length; i++){
                            let boardProfiles = board_profileData.data[i]?.profiles;
                            console.log(boardProfiles.length);
                            let new_profiles = boardProfiles?.filter((candidate)=>candidate['id'] !==id);
                            console.log(new_profiles.length);
                            const { data, error } = await supabase
                            .from("board_clients_invitation")
                            .update({ profiles: new_profiles })
                            .match({id : board_profileData.data[i].id});
                            if(data && data.length){
                                count = 2;
                            }
                        }
                    } else {
                        count = 2;
                    }
                    profilePrecessed++
                    if(profilePrecessed === boardInProfiles.length){
                        callBackOnDeleteFromBoard();
                    }
                })
                let callBackOnDeleteFromBoard = async() => {
                    if(count === 2){
                    var { data, error } = await supabase
                    .from("all_profiles")
                    .delete()
                    .match({ id: id });
                    const response = await supabase
                    .storage
                    .from('data')
                    .remove([`cvs/${cvName}`])
                    if(data && data.length){
                        setShowMessage(true);
                        setSuccessfullMessage("Profile have been deleted from boards successfully.")
                    }
                    else{
                        setShowMessage(true);
                        setSuccessfullMessage("Profile can't be deleted for some reason");
                    }
                    }
                    else{
                        setShowMessage(true);
                        setSuccessfullMessage("Profile can't be deleted for some reason");
                    }
                }
            }
            else{
                var { data, error } = await supabase
                .from("all_profiles")
                .delete()
                .match({ id: id });
                    const response = await supabase
                    .storage
                    .from('data')
                    .remove([`cvs/${cvName}`])
                    if(data && data.length){
                        setShowMessage(true);
                        setSuccessfullMessage("Profile have been deleted successfully.")
                    }
                    else{
                        setShowMessage(true);
                        setSuccessfullMessage("Profile can't be deleted for some reason.");
                    }
                console.log('Profile is deleted!')
            }
        
      }

    const checkError = (candidates) => {
        // this array will contain the gaper ids of 
        // that candidate who's information is not completed
        var erroredProspectsArray = [];
        candidates?.forEach((candidate, index) => {
            for(const key in candidate){
                if(key !== 'memoji' && key !== 'index'){
                    if(candidate[key].length > 0 ){
                        if(key === 'Gaper Id' && !((/[0-9]{4}/).test(candidate[key]))){
                            erroredProspectsArray.push({id: candidate['Gaper Id'], index: index})
                            break;
                        }
                        else if(key === 'Internal Rate' && !((/[0-9A-Za-z]+[/]+[A-Za-z]/).test(candidate[key]))){
                            erroredProspectsArray.push({id: candidate['Gaper Id'], index: index})
                            break;
                        }
                        else if(key === 'Exp' && !((/[0-9]/).test(candidate[key]))){
                            erroredProspectsArray.push({id: candidate['Gaper Id'], index: index})
                            break;
                        }
                        else if(key === 'Email' && !((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(candidate[key]))){
                            erroredProspectsArray.push({id: candidate['Gaper Id'], index: index})
                            break;
                        }
                        else if(key === 'Time zone' && !((/[u]+[t]+[c]+[a-z0-9)+-]{2,}/i).test(candidate[key]))){
                            erroredProspectsArray.push({id: candidate['Gaper Id'], index: index})
                            break;
                        }
                    }
                    else {
                        erroredProspectsArray.push({id: candidate['Gaper Id'], index: index})
                        break;
                    }
                }
            }
        });
        console.log(erroredProspectsArray);
        
        // this unique array contains the gaper id with no duplications
        const uniqueArray = [...new Set(erroredProspectsArray)];
        setWrongProspects(uniqueArray);
    }

    function getRandomColor() {
        var letters = 'BCDEF'.split('');
        var color = '#';
        for (var i = 0; i < 6; i++ ) {
            color += letters[Math.floor(Math.random() * letters.length)];
        }
        return color;
    }

    const getCurrentPost = () => {
        const indexOfLastPost = numberOfCandidatePerPage * currentPage;
        const indexOfFirstPost = indexOfLastPost - numberOfCandidatePerPage;
        if(searchData?.length > 0){
            setDataPerPage(searchData.slice(indexOfFirstPost, indexOfLastPost));
        } else {
            if(toCompleted){
                setDataPerPage(completedProfiles.slice(indexOfFirstPost, indexOfLastPost));
            } else {
                setDataPerPage(candidatesDraft.slice(indexOfFirstPost, indexOfLastPost));
            }
        }
      };

        // change page
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
        });
    };

    const setSelectedRowFunc = (candidate, index) => {
            var selectedObj = candidate;
            selectedObj.index = index;
            setSelected(selectedObj);
            // setGoToCandidateNumber(index+1);
        // 
        // arrow keydown select next row functionality
        // 
        // else {
        //     console.log(selected)
        //     const selectedrowIndex = dataPerPage.indexOf(selected);
        //     console.log(selectedrowIndex);
        // }
    }

    const handleSearchInput = (value) => {
        setSearchValue(value);
        handleSearch(value);
    }

    const handleSearch = (value) => {
        var searchedData;
        if(toCompleted){
            searchedData = completedProfiles.filter((candidate) => {
                return colNames.some((col) => {
                    if(col !== 'memoji'){
                        if(candidate[col]?.toString().toLowerCase().indexOf(value.toLowerCase()) > -1){
                            return candidate;
                        }
                    }
                })
            })
        } else {
            searchedData = candidatesDraft.filter((candidate) => {
                return colNames.some((col) => {
                    if(col !== 'memoji'){
                        if(candidate[col]?.toString().toLowerCase().indexOf(value.toLowerCase()) > -1){
                            return candidate;
                        }
                    }
                })
            })
        }

        setSearchData(searchedData);
        const postsPerPage = numberOfCandidatePerPage
        if(searchedData.length >= postsPerPage){
            const indexOfLastPost = postsPerPage * currentPage;
            const indexOfFirstPost = indexOfLastPost - postsPerPage;
            setDataPerPage(searchedData.slice(indexOfFirstPost, indexOfLastPost));
        } else {
            setCurrentPage(1);
            const indexOfLastPost = postsPerPage * 1;
            const indexOfFirstPost = indexOfLastPost - postsPerPage;
            setDataPerPage(searchedData.slice(indexOfFirstPost, indexOfLastPost));
        }
    }

    const handleChanegNumberOfDataPerPage = (e,type) => {
        setDataPerPageInput(e.target.value)
		if (e.keyCode === 13 || type== "blur") {
            if(e.target.value > 0){
                setNumberOfCandidatePerPage(e.target.value);
            }
            setShowInputBox(false);
            setShowSecondInput(false);
        }
		
	}
    

    {/* On Details Button Click */ }
    const handleDetailsClick = (candidate) => {
        if(miniScreen){
            setShowMiniDrawer(true);
            setCandidateDetails(candidate)
        }
        else{
        setIsDrawerOpen(true)
        console.log(candidate)
        setCandidateDetails(candidate)
        }
    }


    const reportWindowSize = () => {
        var screenSize = window.screen.availWidth;
        if (screenSize < 780) {
          setMiniScreen(true);
        } else {
          setMiniScreen(false);
        }
      }

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => setShowMessage(false)}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );
    return (
        <div className="w-full min-h-screen pb-5 bg-blue-7">
            <div className="sticky top-0 z-50">
                <Header current="home" />
            </div>
            {/* Notification */}
            {
                <Snackbar
                    open={showMessage}
                    onClose={() => setShowMessage(false)}
                    autoHideDuration={2000}
                    message={successfullMessage}
                    action={action}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                />
            }

            {/* loader */}
            {showLoader && (
                <div className="fixed flex items-center justify-center z-10 w-full h-full top-0 bg-white-1">
                {/* Add backdrop */}

                <div className={`relative flex`}>
                    <Oval
                    color="white"
                    secondaryColor="grey"
                    height="40"
                    width="60"
                    />
                    <div className="flex items-center">Hold Tight-just getting this page ready.</div>
                </div>
                </div>
            )}
            {               
                // // miniScreen && wrongProspects?.length > 0 ?
                // <div className="flex justify-center ">
                // <div className="w-[370px] md:w-[720px] bg-white-1 my-10 rounded-lg mx-1">
                //     <div className="px-5 md:pl-24 md:pr-20 py-14">
                // <div className="grid grid-cols-12 gap-3 -mt-1">
                //               {/* Add avatar */}
                //               <div className="mt-5 font-bold col-span-12 "> <img src="missing.svg"/> </div>

                //               {/* Add text */}
                //               <div className="text-[24px] md:text-[24px] mt-5 font-bold col-span-12 ">Some of the information is missing</div>

                //               <div className="text-[18px] md:text-[17px] col-span-10 md:-mt-2 mt-8">We found {wrongProspects?.length} errors in the user prospects.</div>

                //               <div className="text-[18px] md:text-[17px] col-span-10 md:mt-5 mt-8">The information for a few prospects was missing. Kindly correct the errors before moving on.</div>

                //               {/* Add button */}
                //               <div className="col-span-9 mt-7">
                //                 <Button buttonType="next" value="Try Again" className="md:w-[150px] mt-8" onClick={()=>navigate('/addProspect')}/>
                //               </div>
                //             </div>
                //         </div>
                //     </div>
                //     </div>
                
                showMiniDrawer ? 
                    <MiniRightDrawer allGaperIds={allGaperIds} boardInProfiles={boardInProfiles} setBoardInProfiles={(value)=>setBoardInProfiles(value)}  isCompletedTab={toCompleted} showDeleteCandidateModal={showDeleteCandidateModal} setshowDeleteCandidateModal={(value)=>setshowDeleteCandidateModal(value)} wrongProspects={wrongProspects} showMiniDrawer={showMiniDrawer} setShowMiniDrawer={(value)=>setShowMiniDrawer(value)} deleteCandidate={(id,cvName)=>deleteCandidate(id,cvName)} setWrongProspects={(value) => setWrongProspects(value)} candidateDetails={candidateDetails} setShowMessage={(value)=>setShowMessage(value)} setSuccessfullMessage={(value)=>setSuccessfullMessage(value)} setCompletedProfiles={(value)=>setCompletedProfiles(value)} completedProfiles={completedProfiles} setCandidatesDraft={(value)=>setCandidatesDraft(value)} candidatesDraft={candidatesDraft} setIsDrawerOpen={setIsDrawerOpen} />
                    :
                    <>
                <Drawer anchor='right' style={{ zIndex: 49, boxShadow: "0px 12px 15px 0px #0000001A" }} PaperProps={{style: {boxShadow: "0px 4px 4px 0px #40404040", border: "0.5px solid #E1EEF9"}}} open={isDrawerOpen} ModalProps={{BackdropProps: {style: {backgroundColor: 'transparent'}}}} onClose={() => setIsDrawerOpen(false)}>
                    <Box p={4} className="mt-[83px]" width="604px" role='presentation'>
                        <RightDrawer allGaperIds={allGaperIds} boardInProfiles={boardInProfiles} setBoardInProfiles={(value)=>setBoardInProfiles(value)} isCompletedTab={toCompleted} showDeleteCandidateModal={showDeleteCandidateModal} setshowDeleteCandidateModal={(value)=>setshowDeleteCandidateModal(value)} allMemojis={allMemojis} wrongProspects={wrongProspects} setWrongProspects={(value) => setWrongProspects(value)} deleteCandidate={(id,cvName)=>deleteCandidate(id,cvName)} candidateDetails={candidateDetails} setShowMessage={(value)=>setShowMessage(value)} setSuccessfullMessage={(value)=>setSuccessfullMessage(value)} setCompletedProfiles={(value)=>setCompletedProfiles(value)} completedProfiles={completedProfiles} setCandidatesDraft={(value)=>setCandidatesDraft(value)} candidatesDraft={candidatesDraft} setIsDrawerOpen={setIsDrawerOpen} />
                    </Box>
                </Drawer>
                <div>
                    <div className="flex justify-between flex-wrap mt-4 px-5">
                    <div className="flex items-center">
                        <div className={`${toCompleted ? 'font-semibold text-[16px] md:text-[24px]' : 'font-medium text-[16px] md:text-[20px]'} cursor-pointer`} onClick={() => {setToCompleted(true); setCurrentPage(1); setSearchValue(''); setSearchData([]);}}>Complete</div>
                        <div className={`${toCompleted ? 'ml-5 font-medium text-[16px] md:text-[20px]' : 'ml-6  font-semibold text-[16px] md:text-[24px]'} cursor-pointer`} onClick={() => {setToCompleted(false); setCurrentPage(1); setSearchValue(''); setSearchData([]);}}>Drafts</div>
                    </div>
                    <div className="hidden md:flex items-center mt-1">
                        <SearchInput searchValue={searchValue} changeEvent={(value) => handleSearchInput(value)} handleSearch={(value) => handleSearch(value)} />
                    </div>
                    <div className="flex items-center omd-1:mt-3 omd-1:basis-full omd-1:justify-end">
                        {dataPerPage?.length > 0 && <Pagination color='#FFFFFF' totalPosts={searchData?.length > 0 ? searchData?.length : (toCompleted ? completedProfiles?.length : candidatesDraft?.length)} postsPerPage={numberOfCandidatePerPage} paginate={paginate} currentPage={currentPage} />}
                    </div>
                    </div>
                    {/* text */}
                    <div className="flex justify-between mt-2 px-5">
                        <div className={`${wrongProspects?.length > 0 && searchValue?.length <=0 ? 'flex omd-1:items-start text-[#FF0000] space-x-1 omd-1:text-xs' : searchValue?.length > 0 ? 'visible' : 'invisible'}`}>
                            {searchValue?.length > 0 ?
                            <p>Showing Results of <span className="font-semibold">{searchValue}</span></p> :
                            wrongProspects?.length > 0 && <>
                                <img src="./warningIcon.svg" alt="" className={`${toCompleted ? 'invisible' : 'visible'}`}/>
                                <p className={`${toCompleted ? 'invisible' : 'visible'}`}>{wrongProspects.length} user propsect{wrongProspects.length > 1 &&'s'} contain errors</p>
                            </>
                            }
                        </div>
                        {dataPerPage.length > 0 && <div className="text-base omd-1:text-xs font-normal">Displaying 
                            {
                                showInputBox ? <input type="number" max={dataPerPage?.length} min={1} value={dataPerPageInput} autoFocus onChange={(e) => handleChanegNumberOfDataPerPage(e,"")} onKeyDown={(e) => e.keyCode === 13 && handleChanegNumberOfDataPerPage(e,"enter")} onBlur={(e) => handleChanegNumberOfDataPerPage(e,"blur")} style={{"textAlign":'center', "color" : "blue"}} className="inline-flex px-0.5 mx-0.5 bg-white-7 border border-blue-1 min-w-[20px] max-w-[30px] h-6 items-center rounded focus:border-blue-1 focus:border-2 focus:outline-none" /> :
                                <span className="bg-white-1 px-0.5 mx-0.5 rounded-sm cursor-pointer " onClick={()=> setShowInputBox(true)}>{dataPerPage?.length}</span>
                            }
                            /{searchData?.length > 0 ? searchData?.length : (toCompleted ? completedProfiles.length : candidatesDraft.length)} candidates</div>}
                    </div>    
                    
                    <div className="flex overflow-x-scroll">
                    <div className="bg-white-1 mx-5 mt-10 rounded-[8px] py-6 px-2 md:w-full">    
                        <div className="w-[99%] mx-auto">
                            <table className={`table-fixed ${dataPerPage?.length > 0 && 'md:table-auto'} border-separate w-full omd-1:mr-2.5`} style={{'borderSpacing': '0px 6px'}} id="container">
                            
                                <thead className="whitespace-nowrap">
                                    {/* add row */}
                                    <tr className="px-2">
                                        {/* render header */}
                                        <th className="w-[100px] p-3"></th>
                            
                                        {
                                            dataPerPage.length > 0 && colNames.slice(0,7).map((col, index) => {
                                                return <th key={index} className="text-left w-[140px] oxl2:w-48 p-3 box-content">{col}</th>
                                            })
                                        }
                            
                                    <th className="visible md:hidden w-[100px] p-3">  </th>
                                    </tr>
                                </thead>
                            
                            {/* add body */}
                            <tbody >
                                    
                                {/* Render Candidates */}
                                {
                                    dataPerPage.length > 0 ?
                                    dataPerPage.map((candidate, parentIndex) => {
                                        // console.log("value of te",candidate["Time zone"] )
                                        let oldTimeZone = candidate["Time zone"]
                                        candidate["Time zone"] = candidate["Time zone"]?.split(" ")[0]
                                        candidate["Time zone"] = candidate["Time zone"]?.slice(1,candidate["Time zone"].length-1)
                                        // Add row  
                                        return <>
                                        <tr key={parentIndex} id={parentIndex} className={`hover:bg-[#E1EEF975] px-2 box-content`} onClick={(e) => setSelectedRowFunc(candidate,parentIndex)}>
                        
                                            {/* render data */}
                                            <td className={`py-3 ${wrongProspects?.length > 0 && wrongProspects.some((el) => el.id === candidate['Gaper Id']) ? 'bg-[#FEF4F4] border-l border-y border-[#FF0000] border-double rounded-l-[3px]' : (selected && selected["Gaper Id"] === candidate["Gaper Id"] ? `bg-[#E1EEF975] border-l border-y border-double border-blue-1 rounded-l-[3px]` : selected?.index-1 === parentIndex || (wrongProspects.some((el) => el.index-1 === (currentPage > 1 ? (parentIndex + (currentPage - 1) * numberOfCandidatePerPage) : parentIndex)) && !toCompleted) ? '' : 'border-b-[0.25px] border-[#666666]')}`}>
                                                <div style={{backgroundColor: candidate?.memoji?.color}} className={`p-3 mx-auto w-fit rounded-full`} value={candidate?.memoji?.avatar_url}><Avatar src={candidate?.memoji?.avatar_url} imgProps={ {'style':{'objectFit': 'contain'}}} /></div>
                                            </td>
                                            
                                            {
                                                colNames.slice(0,7).map((col,index) => {
                                                    return  <td key={index} className={`my-2 text-left p-3
                                                    ${col === 'Gaper Id' && !((/[0-9]{4}/).test(candidate[col])) && 'text-[#FF0000]'}
                                                    ${col === 'Internal Rate' && !((/[0-9A-Za-z]+[/]+[A-Za-z]/).test(candidate[col])) && 'text-[#FF0000]'}
                                                    ${col === 'Time zone' && !((/[u]+[t]+[c]+[a-z0-9)+-]{2,}/i).test(candidate[col])) && 'text-[#FF0000]'}
                                                    ${wrongProspects?.length > 0 && wrongProspects.some((el) => el.id === candidate['Gaper Id']) ? 'bg-[#FEF4F4] border-y border-[#FF0000] ' : (selected && selected["Gaper Id"] === candidate["Gaper Id"] ? `bg-[#E1EEF975] border-y border-blue-1` : selected?.index-1 === parentIndex || (wrongProspects.some((el) => el.index-1 === (currentPage > 1 ? (parentIndex + (currentPage - 1) * numberOfCandidatePerPage) : parentIndex)) && !toCompleted) ? '' :  'border-b-[0.25px] border-[#666666]')}
                                                    `}>
                                                        {candidate[col]?.length > 0 ? 
                                                        candidate[col] === candidate["Time zone"] ? <Tooltip title={`${oldTimeZone}`} disableInteractive><span>{candidate[col]}</span></Tooltip> : 
                                                        candidate[col] : 
                                                        <div className="flex space-x-1 text-[#FF0000]">
                                                            <img src="./warningIcon.svg" className="" alt="" />
                                                            <p>{col}</p>
                                                        </div>}
                                                    </td>
                                                })
                                            }
                                            {
                                                <td className="hidden">{candidate["Time zone"] = oldTimeZone}</td>
                                            }
                                            <td className={`py-3 ${wrongProspects?.length > 0 && wrongProspects.some((el) => el.id === candidate['Gaper Id']) ? 'bg-[#FEF4F4] border-r border-y border-[#FF0000] border-double rounded-r-[3px]' : (selected && selected["Gaper Id"] === candidate["Gaper Id"] ? `bg-[#E1EEF975] border-r border-y border-double border-blue-1 rounded-r-[3px]` : selected?.index-1 === parentIndex || (wrongProspects.some((el) => el.index-1 === (currentPage > 1 ? (parentIndex + (currentPage - 1) * numberOfCandidatePerPage) : parentIndex)) && !toCompleted) ? '' : 'border-b-[0.25px] border-[#666666]')}`}><Button buttonType="next" value="Details" onClick={() => handleDetailsClick(candidate)} /></td>
                                        
                                        </tr>    
                                        <tr className="visible md:hidden"><Button buttonType="next" value="Details" onClick={() => handleDetailsClick(candidate)} /></tr>  
                                        
                                        
                                        </>
                                        }
                                        )
                                        :
                                        <tr>
                                            <td colSpan={9} className="text-center">No data Avaialble</td>
                                        </tr>
                                    
                                }
                            </tbody>
                        
                        </table>
                        {dataPerPage.length > 0 && <div className="flex justify-between items-center mt-10">
                            <div className="text-base omd-1:text-xs font-normal">Displaying 
                                {
                                    showSecondInput ? <input type="number" max={dataPerPage?.length} min={1} value={dataPerPageInput} autoFocus onChange={(e) => handleChanegNumberOfDataPerPage(e,"")} onKeyDown={(e) => e.keyCode === 13 && handleChanegNumberOfDataPerPage(e,"enter")} onBlur={(e) => handleChanegNumberOfDataPerPage(e,"blur")} style={{"textAlign":'center', "color" : "blue"}} className="inline-flex px-0.5 mx-0.5 bg-white-7 border border-blue-1 min-w-[20px] max-w-[30px] h-6 items-center rounded focus:border-blue-1 focus:border-2 focus:outline-none" /> :
                                    <span className="bg-blue-7 px-0.5 mx-0.5 rounded-sm cursor-pointer" onClick={()=> setShowSecondInput(true)}>{dataPerPage?.length}</span>
                                }
                                {/* <span className="bg-blue-7 px-0.5 rounded-sm">{dataPerPage?.length}</span> */}
                                /{searchData?.length > 0 ? searchData?.length : (toCompleted ? completedProfiles.length : candidatesDraft.length)} candidates</div>
                            <div className="">
                                <Pagination size="small"  color='#E1EEF975' totalPosts={searchData?.length > 0 ? searchData?.length : (toCompleted ? completedProfiles.length : candidatesDraft.length)} postsPerPage={numberOfCandidatePerPage} paginate={paginate} currentPage={currentPage} />
                            </div>
                        </div>}
                        </div>
                    </div>
                    </div>
                </div>
                </>
            }
            
        </div>
    );
}
export default Candidates;
